// Generated cover banner. flory.sh has no banner upload API, so instead of a fake photo we draw a
// deterministic composition from the person/org seed that echoes the mark: two chain-link ovals,
// one of them "open" with the signal wedge, over a tinted field with a ruler along the bottom.
// Decorative only (aria-hidden); theme tokens only, so it follows dark mode.
import { cx } from './cx';

function hash(seed: string): number {
  let h = 2166136261;
  for (const ch of seed) {
    h ^= ch.codePointAt(0)!;
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h;
}

const TINTS = ['--tint-1', '--tint-2', '--tint-3', '--tint-4', '--tint-5', '--tint-6'];

export function CoverBanner({
  seed,
  height = 96,
  className,
}: {
  seed: string;
  height?: number;
  className?: string;
}) {
  const h = hash(seed || 'flory');
  const field = TINTS[h % TINTS.length]!;
  const accent = TINTS[(h >>> 4) % TINTS.length === h % TINTS.length ? (h + 1) % TINTS.length : (h >>> 4) % TINTS.length]!;
  // Oval geometry in a 600x120 box; positions vary by seed but stay readable at any width.
  const x = 300 + ((h >>> 8) % 90);
  const w = 140 + ((h >>> 14) % 50);
  const y = 18 + ((h >>> 20) % 26);
  const oh = 84;
  return (
    <div
      aria-hidden="true"
      className={cx('relative w-full overflow-hidden', className)}
      style={{ height, background: `var(${field})` }}
    >
      <svg
        viewBox="0 0 600 120"
        preserveAspectRatio="xMidYMid slice"
        width="100%"
        height="100%"
        className="absolute inset-0"
      >
        <rect x={x - w * 0.62} y={y} width={w} height={oh} rx={oh / 2} fill={`var(${accent})`} />
        <rect x={x - w * 0.62} y={y} width={w} height={oh} rx={oh / 2} fill="none" stroke="var(--ink)" strokeOpacity="0.16" strokeWidth="6" />
        <path
          d={`M${x + 10} ${y} h${w * 0.35} a${oh / 2} ${oh / 2} 0 0 1 0 ${oh} h-${w * 0.35}`}
          fill="none"
          stroke="var(--ink)"
          strokeOpacity="0.16"
          strokeWidth="6"
        />
        <path d={`M${x - 6} ${y + 16} L${x + 10} ${y} v${oh} l-16 -16 z`} fill="var(--signal)" opacity="0.9" />
      </svg>
      <div className="fl-ruler absolute inset-x-0 bottom-0" style={{ color: 'var(--ink)', opacity: 0.18 }} />
    </div>
  );
}
